<template>
  <div>
    <!-- Sidebar Overlay -->
    <div
      class="body-content-overlay"
      :class="{'show': isCalendarOverlaySidebarActive}"
      @click="isCalendarOverlaySidebarActive = false"
    />
    <calendar-event-handler
      :is-event-handler-sidebar-active="isEventHandlerSidebarActive"
      :event="event"
      @show-hide-sidebar="(val) => $emit('update:is-event-handler-sidebar-active', val)"
      @remove-event="(eventId, processer) => removeEvent(eventId, processer)"
      @update-shift="updateShift"
      @create-gig-and-update-shift="createGigAndUpdateShift"
      @sidebar-open="fetchLocationDetails"
      @send-verification="sendVerification"
      @send-cancel-notification="sendCancelNotification"
      @publish-shifts="publishShifts"
      @search-user="searchUsers"
      @fetch-user-upcoming-shifts="fetchUserUpcomingShifts"
      @search-location="onSearchLocation"
    />
  </div>
</template>
<script>
import { onUnmounted } from '@vue/composition-api'
import store from '@/shared/store'
import calendarStoreModule from '@/1-shifts-&-gigs/store/calendarStoreModule'
import CalendarEventHandler from './CalendarEventHandler.vue'
import useManageShiftSidebar from './useManageShiftSidebar'


export default {
  components: {
    CalendarEventHandler,
  },
  model: {
    prop: 'isEventHandlerSidebarActive',
    event: 'update:is-event-handler-sidebar-active',
  },
  props: {
    isCalendarOverlaySidebarActive: {
      type: Boolean,
      default: false,
    },
    isEventHandlerSidebarActive: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, {emit}) {
    const USER_APP_STORE_MODULE_NAME = 'appCalendar'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, calendarStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })
    const {
      updateShift,
      createGigAndUpdateShift,
      fetchLocationDetails,
      searchUsers,
      sendVerification,
      sendCancelNotification,
      publishShifts,
      removeEvent,
      fetchUserUpcomingShifts,
      onSearchLocation,
    } = useManageShiftSidebar(emit)

    return {
      updateShift,
      createGigAndUpdateShift,
      fetchLocationDetails,
      searchUsers,
      sendVerification,
      sendCancelNotification,
      publishShifts,
      fetchUserUpcomingShifts,
      removeEvent,
      onSearchLocation,
    }
  },
}
</script>